import type { PublicClientEnv } from "@luckymenu/config";

declare const __LM_ENV__: PublicClientEnv;

/** Publishable values baked in at build time. See vite.config.ts. */
export const env: PublicClientEnv = __LM_ENV__;
